import { useMutation, useQuery } from "@tanstack/react-query";
import { AddResultPayload } from "../../Constants/Interfaces/payloadInterface/ResultsPayload.interface";
import { get, post } from "../../api/client";
import queryClient from "../../config/queryClient";

export const Results_key = {
  RESULT_LISTS: "RESULT_LISTS",
  RESULT_DETAILS: "RESULT_DETAILS",
};

export const useAddResult = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => unknown;
  onError: (err: Error) => unknown;
}) =>
  useMutation(
    (body: AddResultPayload) => {
      return post({
        url: "api/v1/results/add",
        body,
      });
    },
    {
      onSuccess: () => {
        onSuccess();
        queryClient.invalidateQueries({
          queryKey: [Results_key.RESULT_LISTS],
        });
      },
      onError: (err: Error) => onError(err),
    }
  );

export const useGetAllResults = ({ page = 1 }: { page: number }) => {
  return useQuery([Results_key.RESULT_LISTS, page], () => {
    return get({
      url: "api/v1/results",
      params: {
        page,
      },
    });
  });
};

export const useGetResultDetails = ({ resultId }: { resultId: number }) => {
  return useQuery([Results_key.RESULT_DETAILS, resultId], () => {
    return get({
      url: `api/v1/results/${resultId}`,
    });
  });
};
